import React, {useState} from 'react';
import s from "../teamsTab.module.scss";
import MuiTooltip from "../../../../../../../components/UiKit/MuiTooltip/MuiTooltip";
import SvgSelector from "../../../../../../../components/SvgSelector/SvgSelector";
import {convertDate} from "../../../../../../../utils/helpers/formatTime";
import {useTranslation} from "react-i18next";
import SetTeamNamePopup from "../../../Popups/SetTeamNamePopup/SetTeamNamePopup";
import {setSelectedTeamId} from "../../../../../../../redux/slices/teamsSlice";
import {useDispatch, useSelector} from "react-redux";
import useCustomSnackbar from "../../../../../../../hooks/useCustomSnackbar";
import {snackbar_error, snackbar_warning} from "../../../../../../../utils/vars/staticVariables";
import ConfirmPopup from "../../../../../../../components/UiKit/Popups/ConfirmPopup/ConfirmPopup";
import {subscriptionSelector} from "../../../../../../../redux/slices/subscriptionSlice";
import {WILD} from "../../../../Subscriptions/Subscriptions";

const TeamTr = ({
                    name,
                    id,
                    clients_count,
                    editTeamNameHandler,
                    setOwnerAddUserPopupActive,
                    onRemoveTeamHandler,
                    checkIfCanAddUserToTeam
                }) => {
    const [isActiveSetNamePopup, setActiveSetNamePopup] = useState(false);
    const [isActiveRemoveTeamPopup, setActiveRemoveTeamPopup] = useState(false);

    const {activeSubscription, can_tm_add_count} = useSelector(subscriptionSelector)

    const {t} = useTranslation();

    const dispatch = useDispatch();

    const showSnackbar = useCustomSnackbar();

    return (
        <tr>
            <td className={s.nameTd}>
                <SetTeamNamePopup
                    active={isActiveSetNamePopup}
                    setActive={setActiveSetNamePopup}
                    title={t("team_name")}
                    name={name}
                    id={id}
                    icon={<SvgSelector id="note-popup-icon"/>}
                    handler={editTeamNameHandler}
                />

                <div className={s.editNameField}>
                    <button
                        className={s.nameTextBtn}
                        onClick={() => setActiveSetNamePopup(true)}
                    >
                        <div className={s.nameText}>{name}</div>
                        <MuiTooltip title={name}></MuiTooltip>
                        <SvgSelector id="edit-icon"/>
                    </button>
                </div>
            </td>
            <td>{clients_count}</td>
            <td className={s.actionsTd}>
                <ConfirmPopup
                    icon={<SvgSelector id="popup-remove-icon"/>}
                    active={isActiveRemoveTeamPopup}
                    setActive={setActiveRemoveTeamPopup}
                    action={() => onRemoveTeamHandler(id)}
                    confirmBtnText={t("button_remove")}
                    title={t("team_removing")}
                    description={
                        <>
                            {t("want_to_remove")}{" "}
                            <span
                                style={{
                                    color: "#fff",
                                    fontWeight: 500,
                                    marginLeft: 5,
                                    marginRight: 5,
                                }}
                            >
                              {name}
                            </span>
                            ?
                        </>
                    }
                />
                <div className={s.actionsWrapper}>
                    <div className={s.actionsContainer}>
                        <div className={s.actions}>
                            <button
                                className={`${s.manageTableFillBtn} ${s.statsBtn}`}
                                onClick={() => {
                                    // if (can_tm_add_count < 1) {
                                    //     return showSnackbar(
                                    //         t("reached_subscription_users_limit"),
                                    //         snackbar_warning,
                                    //     );
                                    // }
                                    const messageShown = checkIfCanAddUserToTeam();  // Перевірка результату

                                    if (messageShown) {
                                        return;  // Якщо сповіщення показано, зупиняємо виконання коду
                                    }

                                    dispatch(setSelectedTeamId(id))
                                    setOwnerAddUserPopupActive(true)
                                }}
                            >
                                <MuiTooltip title={t("add_user")}>
                                    <SvgSelector id="add-team-user-icon"/>
                                </MuiTooltip>
                            </button>
                            <button
                                className={s.removeBtn}
                                onClick={() => setActiveRemoveTeamPopup(true)}
                            >
                                <MuiTooltip title={t("button_remove")}>
                                    <SvgSelector id="new-remove-icon"/>
                                </MuiTooltip>
                            </button>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    )
}

export default TeamTr;